import { Textinput } from '@yandex-360/orb-components/dist/components/Textinput';

export default Textinput;
